import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { svgToFile } from "@/lib/geometry";
import { btnNavy, useScope } from "@/components/MathShell";
import { Spin, Sel } from "@/components/common";

const L = "ABCDE";

export function GeoQuestionGen({ quiz, target, setTarget, hideAsked, setHideAsked, svgRef, tool, onQuestion, disabled }) {
  const [scope] = useScope();
  const nav = useNavigate();
  const [count, setCount] = useState(3);
  const [diff, setDiff] = useState("Orta");
  const [cmd, setCmd] = useState("");
  const [busy, setBusy] = useState(false);
  const [out, setOut] = useState([]);
  const t = quiz.targets.find((x) => x.key === target) || quiz.targets[0];
  const editor = !!onQuestion;
  const go = async () => {
    setBusy(true);
    try {
      const f = await svgToFile(svgRef.current, `geometri_${tool}.png`);
      let image_url = "";
      if (!editor) { const fd = new FormData(); fd.append("file", f); fd.append("kind", "Geometri"); image_url = (await api.post("/assets", fd)).data.url; }
      const { data } = await api.post("/math/ai/geometry-questions", { grade: scope.grade, level: scope.level, difficulty: diff, count: editor ? 1 : count, target: t.label, answer: t.answer,
        facts: quiz.facts(hideAsked ? t.key : ""), command: cmd, image_url, save: !editor });
      if (editor) { await onQuestion(data[0], f); toast.success("Soru editöre dolduruldu — düzenleyip kaydedin"); }
      else { setOut(data); toast.success(`${data.length} soru havuza kaydedildi`); }
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border p-4 space-y-3 bg-[#fbfcfd]" data-testid="geo-qgen">
      <div className="font-bold text-navy flex items-center gap-2"><Sparkles size={16} className="text-teal" /> Bu şekilden AI soru üret</div>
      <div className="grid sm:grid-cols-[1fr_110px_90px] gap-2 text-sm">
        <div><div className="lbl">Sorulacak değer</div><Sel value={t.key} onChange={setTarget} options={quiz.targets.map((x) => ({ value: x.key, label: x.label }))} testid="geo-q-target" /></div>
        <div><div className="lbl">Zorluk</div><Sel value={diff} onChange={setDiff} options={["Kolay", "Orta", "Zor"]} testid="geo-q-diff" /></div>
        {!editor && <div><div className="lbl">Adet</div><Sel value={String(count)} onChange={(v) => setCount(Number(v))} options={["1", "2", "3", "4", "5"]} testid="geo-q-count" /></div>}
      </div>
      {t.answer && <div className="text-xs text-[#5f6f84]" data-testid="geo-q-answer">Hesaplanan doğru cevap: <b className="text-navy">{t.answer}</b></div>}
      <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={hideAsked} onChange={(e) => setHideAsked(e.target.checked)} data-testid="geo-q-hide" /> Sorulan değeri şekilde "?" olarak gizle</label>
      <input className="inp text-sm" value={cmd} onChange={(e) => setCmd(e.target.value)} placeholder="Ek komut (ör. LGS yeni nesil, günlük hayattan bahçe örneği)" data-testid="geo-q-command" />
      <button onClick={go} disabled={busy || disabled} className={`${btnNavy} w-full py-2.5 text-sm flex items-center justify-center gap-2`} data-testid="geo-q-generate-btn">{busy ? <Spin size={14} /> : <Sparkles size={15} />} {editor ? "Soru üret ve editöre doldur" : `${count} soru üret ve havuza kaydet`}</button>
      {out.length > 0 && <div className="space-y-2" data-testid="geo-q-results">{out.map((q, k) => <button key={q.id} onClick={() => nav(`/matematik/soru/${q.id}`)} className="w-full text-left border rounded-lg p-3 bg-white hover:border-[#127C8E] text-sm" data-testid={`geo-q-result-${k}`}>
        <div className="font-semibold text-navy">{k + 1}. {q.text}</div><div className="text-xs mt-1 text-[#5f6f84]">{q.options.map((o, j) => `${L[j]}) ${o}`).join("   ")}</div>
        <div className="text-xs mt-1 text-[#2f8a4c] flex items-center gap-1"><CheckCircle2 size={12} /> Doğru: {L[q.correct]} · havuzda — düzenlemek için tıklayın</div></button>)}</div>}
    </div>
  );
}
